import { defineMessages } from 'react-intl';

export const messages: {
	noResults: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	noResults: {
		id: 'ai-mate.inline-browse.no-results',
		defaultMessage: 'No results found',
		description: 'Text displayed when no results match the search',
	},
});
